module.exports = __webpack_public_path__ + "img/sunshine_1920.a1badb12.png";